import { createSelector } from 'reselect';
import { get, identity } from 'lodash/fp';

const toolboxSelector = createSelector(get('toolbox'), identity);

export default toolboxSelector;
